import { createContext } from "react";

const ComponentCarouselContext = createContext(null);

export { ComponentCarouselContext };
